<template>

  <b-row v-if="esDermatologia">
    <b-col>
      <b-card
        
        no-body
        :class="{ 'open': visibleBody }"
      >
        <b-card-header
          :class="{ 'collapsed': !visibleBody }"
          :aria-expanded="visibleBody ? 'true' : 'false'"
          role="tab"
          data-toggle="collapse"
          @click="onVisibleBody(!visibleBody)"
          style="padding: 0 1px; color: black; font:45px; cursor: pointer;"
        >
          <span class="lead collapse-title">
            <strong>Antecedentes Dermatología</strong>
          </span>
          <i :class="visibleBody ? 'fas fa-chevron-up' : 'fas fa-chevron-down'"/>
        </b-card-header>

        <b-collapse
          v-model="visibleBody"
          role="tabpanel"
        >
          <b-card-body style="padding: 1.5rem">
            <b-row>
              <b-col>
                <b-form-group>
                  <hr>
                  <label for="" style="font-size: small;" class="mb-1">
                    ¿Ha experimentado alguno de los siguientes síntomas? (Seleccione todos los que apliquen)
                  </label>

                  <v-select
                    placeholder="Seleccione una o mas opciones"
                    :options="sintomasOpts"
                    :reduce="option => option"
                    label="text"
                    :multiple="true"
                    taggable
                    @input="newArray => dermatologia.sintomas = onAddNewOpt(newArray)"
                  />
                </b-form-group>

                <b-form-group class="my-2" v-if="isVisibleDermatoComienzo">
                  <hr>
                  <label for="" style="font-size: small;" class="mb-1">¿Cuándo comenzaron sus síntomas?</label>
                  <v-select
                    placeholder="Seleccione una o mas opciones"
                    :options="comienzoOpts"
                    :reduce="option => option"
                    label="text"
                    v-model="dermatologia.comienzo"
                  />
                </b-form-group>

                <b-form-group class="my-2" v-if="isVisibleDermatoFactores">
                  <hr>
                  <label for="" style="font-size: small;" class="mb-1">
                    ¿Factores de riesgo?
                  </label>

                  <v-select
                    placeholder="Seleccione una o mas opciones"
                    :options="factoresOpts"
                    :reduce="option => option"
                    label="text"
                    :multiple="true"
                    taggable
                    @input="newArray => dermatologia.factoresRiesgo = onAddNewOpt(newArray)"
                  />
                </b-form-group>
                
                <b-form-group class="my-2" v-if="isVisibleDermatoTratamientos">
                  <hr>
                  <label for="" style="font-size: small;" class="mb-1">
                    ¿Recibe actualmente algún tipo de tratamiento? (Seleccione todos los que apliquen)
                  </label>


                  <v-select
                    placeholder="Seleccione una o mas opciones"
                    :options="tratamientosOpts"
                    :reduce="option => option"
                    label="text"
                    :multiple="true"
                    taggable
                    @input="newArray => dermatologia.tratamientos = onAddNewOpt(newArray)"
                  />

                </b-form-group>
              </b-col>
            </b-row>
          </b-card-body>
        </b-collapse>
      </b-card>
    </b-col>
  </b-row>
  
</template>

<script>
import vSelect from "vue-select";
import { addNewOpt } from '@/shared/helpers';
import { mapState } from "vuex";

export default {
  name: "SemiologiaDermatologica",

  components: {
    vSelect
  },

  data() {
    return {
      visibleBody: true,
      dermatologia:{
        sintomas:[],
        comienzo:null,
        factoresRiesgo:[],
        tratamientos:[],
      },

      isVisibleDermatoComienzo:false,
      isVisibleDermatoFactores:false,
      isVisibleDermatoTratamientos:false,

      sintomasOpts:[
        { value: 'erupciones',      text: 'Erupciones cutáneas' },
        { value: 'picazon',         text: 'Picazón (prurito)' },
        { value: 'enrojecimiento',  text: 'Enrojecimiento' },
        { value: 'sequedad',        text: 'Sequedad de la piel' },
        { value: 'lesiones',        text: 'Lesiones cutáneas' },
        { value: 'perdidaCabello',  text: 'Pérdida de cabello' },
        { value: 'uñasQuebradizas', text: 'Uñas quebradizas o deformadas' },
        { value: 'heridas',         text: 'Heridas que no cicatrizan' },
        { value: 'cambioLunares',   text: 'Cambio en lunares o manchas' }
      ],

      comienzoOpts:[
        { value: 'dias',    text: 'días' },
        { value: 'semanas', text: 'semanas' },
        { value: 'meses',   text: 'meses' },
        { value: 'anios',  text: 'años' }
      ],

      factoresOpts: [
        { value: 'exposicion_prolongada_al_sol',    text: 'Exposición prolongada al sol' },
        { value: 'productos_quimicos_agresivos',    text: 'productos químicos agresivos' },
        { value: 'alergias',                        text: 'Alergias' },
        { value: 'sistema_inmunologico_debilitado', text: 'Sistema inmunológico debilitado' },
        { value: 'estres',                          text: 'Estrés' },
        { value: 'historia_familiar_de_enfermedades_de_la_piel', text: 'Historia familiar de enfermedades de la piel' },
      ],

      tratamientosOpts : [
        { value: 'cremas_topicas',      text: 'Cremas tópicas' },
        { value: 'medicamentos_orales', text: 'Medicamentos orales' },
        { value: 'fototerapia',         text: 'Fototerapia' },
        { value: 'cirugia',             text: 'Cirugía' }
      ]
    }
  },

  methods: {
    onVisibleBody(value) {
      this.visibleBody = value;
    },

    onAddNewOpt(newArray) {
      return addNewOpt(newArray);
    }
  },
  computed:{
    ...mapState({
      stDataDoctor: state => state.atencionCita.dataCita?.doctor
    }),

    esDermatologia(){
      return this.stDataDoctor?.especialidad?.codEsp === '0000000524';
    },

  },

  watch: {
    dermatologia: {
      handler(newValue) {
        this.isVisibleDermatoComienzo     = newValue.sintomas.length > 0;
        this.isVisibleDermatoFactores     = newValue.comienzo && this.isVisibleDermatoComienzo;
        this.isVisibleDermatoTratamientos = newValue.factoresRiesgo.length > 0 && this.isVisibleDermatoFactores;
      },
      deep: true
    }
  },
}
</script>

<style>
  .checkbox-sintomas .custom-check {
    width: 100%;
  }

  .otros-check .custom-control-label{
    display: flex;
    width: 100%;
  } 
</style>
